import type { HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

type Variant = 'info' | 'success' | 'warning' | 'danger';

const bar: Record<Variant, string> = {
  info: 'bg-info',
  success: 'bg-success',
  warning: 'bg-warning',
  danger: 'bg-danger',
};

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  variant?: Variant;
}

/** A notice with a semantic left bar — the color and the bar together let the
 * severity read at a glance. */
export function Alert({ variant = 'info', className, children, ...props }: AlertProps) {
  return (
    <div
      className={cn(
        'flex gap-3 rounded-sm border border-hairline bg-surface p-4 text-sm text-haze',
        className,
      )}
      {...props}
    >
      <div className={cn('w-[3px] flex-none rounded-sm', bar[variant])} />
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
